// extracted by mini-css-extract-plugin
module.exports = {"icon":"favoriteIcon__icon___YQWG3","is-active":"favoriteIcon__is-active___9bAyZ"};